import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get costCenterType
export const getCostCenterType = createAsyncThunk(
  "costCenterType/getCostCenterType",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo } = params;
      const { data } = await API.getCostCenterType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all costCenterType
export const getAllCostCenterType = createAsyncThunk(
  "costCenterType/getAllCostCenterType",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllCostCenterType();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("costCenterType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("costCenterType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "costCenterType/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageCostCenterType({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create costCenterType
export const createCostCenterType = createAsyncThunk(
  "costCenterType/createCostCenterType",
  async (data, { rejectWithValue }) => {
    const { name, code, isActive } = data;
    try {
      const body = JSON.stringify({ name, code, isActive });
      const { data } = await API.createCostCenterType(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateCostCenterType = createAsyncThunk(
  "costCenterType/updateCostCenterType",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, code, isActive } = values;
    try {
      const body = JSON.stringify({ name, code, isActive });
      const { data } = await API.updateCostCenterType(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("costCenterType/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCostCenterType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
